// config
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

// auth
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
